module.exports = __webpack_public_path__ + "static/media/Lato-Italic.4eb103b4.woff2";